import { SingleTenantId } from '@wemogy/reactbase-authorization'
import { useModalStore } from '@wemogy/reactbase';
import { useCallback } from 'react';
import useDataAccessStore from '../../../../dataLayer/stores/hooks/UseDataAccessStore';
import IMember from '../../../containers/authorizationTmp/member/interfaces/IMember';
import IMemberManagementProps from '../../../containers/authorizationTmp/memberManagementCreator/IMemberManagementProps';
import createMemberManagementComponent from '../../../containers/authorizationTmp/memberManagementCreator/MemberManagementComponentCreator';
import NotificationManager from '../../../wrappers/inAppFeedback/NotificationManager';
import RestApiServiceFactory from '../../../../dataLayer/api/rest/RestApiServiceFactory';

const FormMemberManagement: React.FC<IMemberManagementProps> = createMemberManagementComponent({
  pathIndex: 0,
  levelIndex: 2,
  hooks: {
    useMembersDeletedHandlerHook: () => {
      const modalStore = useModalStore();
      const { formStore } = useDataAccessStore();

      return (resourceId: string, subjectIds: string[]): void => {
        // ToDo: fix useSubjectsAddedHandlerHook
        modalStore.openModal('loadingOverlay', 'Wird gelöscht');
        RestApiServiceFactory.memberApiService.deleteMemberAsync(
          'form',
          SingleTenantId,
          resourceId,
          subjectIds
        )
          .then((): void => {
            const form = formStore.getItem(resourceId);
            if (!form) {
              return;
            }

            subjectIds.map(subjectId => form.deleteMember(subjectId));
            NotificationManager.success('Erfolgreich gelöscht');
          })
          .finally((): void => modalStore.closeModal());
      }
    },
    useSubjectsAddedHandlerHook: () => {
      const modalStore = useModalStore();
      const { formStore } = useDataAccessStore();

      return (resourceId: string, subjectIds: string[], roleId: string): void => {
        // ToDo: fix useSubjectsAddedHandlerHook
        modalStore.openModal('loadingOverlay');
        RestApiServiceFactory.memberApiService.upsertMemberAsync(
          'form',
          SingleTenantId,
          resourceId,
          roleId,
          subjectIds
        )
        .then((): void => {
          const form = formStore.getItem(resourceId);
          if (!form) {
            return;
          }

          subjectIds.map(subjectId => form.putMember(subjectId, roleId));

          NotificationManager.success('Erfolgreich geändert');
        })
          .finally((): void => modalStore.closeModal());
      }
    },
    useMembersResolverHook: (resourceId: string): IMember[] => {
      const {
        formStore, userStore
      } = useDataAccessStore();

      const form = formStore.getItem(resourceId);

      if (!form) {
        return [];
      }

      return form.members.filter(x => userStore.getItem(x.userId) !== undefined).map((member): IMember => {
        const user = userStore.getItem(member.userId);

        if (!user) {
          throw new Error('');
        }

        return {
          id: user.id,
          email: user.email,
          username: user.fullname,
          roleId: member.roleId
        };
      }).filter(x => x !== undefined);
    },
    useMemberRoleIdChangedHandlerHook: () => {
      const {formStore} = useDataAccessStore();
      const modalStore = useModalStore();

      const memberRoleIdChangedHandler = useCallback(
        (subjectId: string, resourceId: string, roleId: string): void => {
          modalStore.openModal(
            'loadingOverlay',
            'Zuweisung wird durchgeführt',
          );

          RestApiServiceFactory.memberApiService
            .upsertMemberAsync('form', SingleTenantId, resourceId, roleId, [
              subjectId,
            ])
            .then((): void => {
              formStore.getItem(resourceId)?.putMember(subjectId, roleId);

              NotificationManager.success(
                'Die Zuweisung wurde erfolgreich gespeichert',
              );
              console.log('changed customer role to', roleId);
            })
            .finally(() => modalStore.closeModal());
        },
        [formStore],
      );

      return memberRoleIdChangedHandler;
    },

  }
});

export default FormMemberManagement;
